import styled from 'styled-components';
import { Modal, Header } from 'semantic-ui-react';

export const TimeoutMessageModal = styled(Modal)`
  max-width: 300px !important;

  min-height: 100px;
  i {
    color: #000 !important;
    right: 0 !important;
    top: 0 !important;
  }
`;
export const TimeoutMessageModalContent = styled(Modal.Content)`
  background-color: #f6f3f3 !important;

  border-radius: 0px !important;
  color: #000;
  height: 100%;
  padding: 20px;
  text-align: center;
  width: 100% !important;
`;
export const TimeoutMessageModalDescription = styled(Modal.Description)`
  display: flex !important;
  flex-direction: column;
  height: 100%;
`;

export const TimeoutMessageModalHeader = styled(Header)`
  color: #000 !important;
  flex-grow: 1;
  font-family: 'Neutraface';
  font-size: 18px;
  padding-top: 40px !important;
`;

export const TimeoutMessageModalBody = styled.div`
  flex-grow: 2;
  font-family: 'OpenSansRegular';
  padding: 20px 0;
`;

export const TimeoutMessageModalFooter = styled.div`
  font-family: 'OpenSansRegular';

  a {
    color: #000;
    text-decoration: underline;

    &:hover {
      color: #000;
      font-weight: bold;
      text-decoration: underline;
    }
  }
`;
